import { Component, OnInit, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { QuestiondifficultyService } from 'src/app/providers/questiondifficulty/questiondifficulty.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-questiondifficulty-modal',
  templateUrl: './questiondifficulty-modal.component.html',
  styleUrls: ['./questiondifficulty-modal.component.scss']
})
export class QuestionDifficultyModalComponent implements OnInit {
  questionDifficultyForm: FormGroup;

  local_data: any;
  id: number;
  description: string;
  name: string;

  constructor(public fb: FormBuilder, public dialogRef: MatDialogRef<QuestionDifficultyModalComponent>,
    private questDiffService: QuestiondifficultyService, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    this.local_data = { ...data };
    this.id = this.local_data.id;

    if (!this.id) {
      this.createForm();
    } else {
      this.editForm();
    }
  }

  createForm() {
    this.questionDifficultyForm = new FormGroup({
      name: new FormControl(),
      description: new FormControl()

    });

    this.questionDifficultyForm = this.fb.group({
      name: ['', [Validators.required]],
      description: ['', [Validators.required]]

    })
  }

  editForm() {
    this.questionDifficultyForm = new FormGroup({
      name: new FormControl(),
      description: new FormControl()
    });

    this.questionDifficultyForm = this.fb.group({
      name: [this.data.name, [Validators.required]],
      description: [this.data.description, [Validators.required]]
    })
  }

  addQuestionDifficulty() {

    if (!this.id) {
      console.log(this.questionDifficultyForm.value);
      this.questDiffService.addQuestionDifficulty(this.questionDifficultyForm.value)
        .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );

    } else {
      console.log(this.questionDifficultyForm.value);
      this.questDiffService.editQuestionDifficulty(this.id, this.questionDifficultyForm.value)
        .pipe(map(
          data => { console.log(data); return data },
          err => { console.log(err); return err }
        ))
        .subscribe(
          data => {
            return data;
          },
          err => { alert("Invalid data"); console.log(err) }
        );
    }


  }

  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
  }

}

